(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.initHotspots();

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener(
          'page:loaded',
          () => this.initQuickShop(),
          { once: true, signal }
        );
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener(
          'scroll',
          () => {
            this.querySelectorAll('kit-popover:popover-open').forEach((popover) => {
              popover.hidePopover?.();
            });
          },
          { passive: true, signal }
        );
      }

      if (!Shopify.designMode) return;

      document.addEventListener(
        'shopify:section:load',
        (event) => {
          if (event.target.contains(this)) {
            this.initHotspots();
            this.initQuickShop();
          }
        },
        { signal }
      );

      this.addEventListener(
        'shopify:block:select',
        (event) => {
          this.initHotspots();
          this.initQuickShop();

          const btn = event.target.querySelector('.shoppable-hero__btn');
          if (btn && !btn.disabled) btn.click();
        },
        { signal }
      );

      this.addEventListener(
        'shopify:block:deselect',
        (event) => {
          const popover = event.target.querySelector('kit-popover');
          if (popover) popover.hidePopover?.();
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initHotspots() {
      const signal = this.abortController?.signal;
      const hotspots = this.querySelectorAll('.kit-shoppable-hero__hotspot');

      hotspots.forEach((hotspot) => {
        if (hotspot.dataset.shoppableHeroPopoverBound === 'true') return;

        const button = hotspot.querySelector('.shoppable-hero__btn[popovertarget]');
        if (!button) return;

        const popoverId = button.getAttribute('popovertarget');
        const popover = popoverId ? document.getElementById(popoverId) : null;
        if (!popover) return;

        hotspot.dataset.shoppableHeroPopoverBound = 'true';

        const showPopover = () => {
          if (!popover.matches(':popover-open')) {
            popover.showPopover?.();
          }
        };

        hotspot.addEventListener('mouseenter', showPopover, { signal });
        hotspot.addEventListener('focusin', showPopover, { signal });
      });
    }

    initQuickShop() {
      if (!window.theme || !theme.settings?.quickView) return;

      const sectionEl = this.closest('[id^="shopify-section-"]');
      const links = this.querySelectorAll(
        '.shoppable-hero__popover-link[data-product-handle]'
      );

      if (!links.length) return;

      links.forEach((link) => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        const handle = link.dataset.productHandle;
        const productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        link.addEventListener(
          'click',
          (event) => {
            if (theme.config.bpSmall) {
              event.stopImmediatePropagation();
              return;
            }

            const popover = event.target.closest('kit-popover');
            if (popover) popover.hidePopover?.();
          },
          { capture: true, signal: this.abortController.signal }
        );

        const hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        const preloadOnce = () => {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          const holder = document.getElementById('QuickShopHolder-' + handle);

          if (holder && sectionEl) {
            const holderSection = holder.closest('[id^="shopify-section-"]');

            if (holderSection && holderSection !== sectionEl) {
              const duplicate = sectionEl.querySelector(
                '#QuickShopModal-' + productId
              );

              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce, {
          signal: this.abortController.signal
        });

        hotspot.addEventListener('focusin', preloadOnce, {
          signal: this.abortController.signal
        });
      });
    }
  }

  if (!customElements.get('kit-shoppable-hero')) {
    customElements.define('kit-shoppable-hero', KitShoppableHero);
  }

  } catch(e) { console.error(e); }
})();
})();
